import { MemberElectionsPageContent } from "./_components/MemberElectionsPageContent";

export default function PendingMemberElectionsPage() {
  return <MemberElectionsPageContent activeTab="pending" />;
}
